import React from 'react';
import { ArrowRight, CalendarCheck } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

const HERO_IMG = '/api/static/branding/magasin-1.jpg';

export const MrgHero = ({ id = {}, colors = {}, setView }) => {
  const navigate = useNavigate();
  const primary = colors.primary || '#1B2A4A';
  const accent = colors.accent || '#C9A24B';
  const sub = id.hero_subtitle || 'Opticien & Audioprothésiste à Istres';
  const heroImg = id.hero_image_url || HERO_IMG;
  const videoId = id.hero_video_id || 'JDRcBmcIf98'; // META x Ray-Ban

  return (
    <section className="relative overflow-hidden bg-black" style={{ minHeight: 'clamp(520px, 82vh, 820px)' }} data-testid="mrg-hero">
      <div className="absolute inset-0 overflow-hidden">
        <img src={heroImg} alt="" className="absolute inset-0 w-full h-full object-cover" loading="eager" />
        <iframe
          title="MRG x Ray-Ban"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&showinfo=0&modestbranding=1&playsinline=1&rel=0&disablekb=1&vq=hd1080&hd=1`}
          className="absolute top-1/2 left-1/2 pointer-events-none border-0"
          style={{ width: '100vw', height: '56.25vw', minWidth: '177.78vh', minHeight: '100vh', transform: 'translate(-50%, -50%)' }}
          allow="autoplay; encrypted-media; picture-in-picture" frameBorder="0"
        />
      </div>
      <div className="absolute inset-0" style={{ background: `linear-gradient(100deg, ${primary}F2 0%, ${primary}CC 38%, ${primary}55 70%, transparent 100%)` }} />

      <div className="relative z-10 max-w-[1320px] mx-auto px-6 h-full flex items-center" style={{ minHeight: 'clamp(520px, 82vh, 820px)' }}>
        <div className="max-w-2xl py-20">
          <span className="inline-flex items-center gap-2.5 text-white/80 text-[12px] font-semibold uppercase tracking-[0.32em] mb-6">
            <span className="h-px w-9" style={{ backgroundColor: accent }} /> {sub}
          </span>
          <h1 className="text-white font-semibold leading-[0.98]" style={{ fontFamily: "'Poppins', sans-serif", fontSize: 'clamp(44px, 6.5vw, 90px)', letterSpacing: '-0.02em' }}>
            Voir le monde<br /><span style={{ color: accent }}>avec style.</span>
          </h1>
          <p className="text-white/75 text-[16px] md:text-[19px] mt-6 max-w-xl leading-relaxed">
            Les plus grandes marques de lunettes solaires et optiques, des conseils d’experts et un essayage en boutique. La vue et l’audition, sublimées.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <button onClick={() => (setView ? setView('shop') : navigate('/'))}
              className="group inline-flex items-center gap-2.5 px-8 py-4 rounded-full text-[15px] font-bold transition-transform hover:scale-105"
              style={{ backgroundColor: accent, color: '#ffffff' }} data-testid="mrg-hero-shop">
              Découvrir la boutique <ArrowRight size={18} weight="bold" className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button onClick={() => navigate('/rendez-vous')}
              className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full text-[15px] font-bold text-white border border-white/30 hover:bg-white/10 transition-colors"
              data-testid="mrg-hero-rdv">
              <CalendarCheck size={18} weight="bold" /> Prendre rendez-vous
            </button>
          </div>
          <div className="mt-10 flex flex-wrap items-center gap-x-7 gap-y-2 text-white/65 text-[13px]">
            {['+30 grandes marques', 'Tiers payant mutuelles', 'Retrait en magasin', 'Conseils d’experts'].map((t, i) => (
              <span key={i} className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: accent }} /> {t}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MrgHero;
